/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Parts
 *
 * 1 = Authorisation
 *
 * 2 = Authorized
 */
export enum UserNotificationType {
  Parts = 0,
  Authorisation = 1,
  Authorized = 2,
}
